"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItemImage_1 = __importDefault(require("./NotificationItemImage"));
var time_1 = __importDefault(require("../../lib/time"));
require("./NotificationItem.css");
var NewNotification_1 = __importDefault(require("../Icons/Notifications/NewNotification"));
function NotificationItem(_a) {
    var image = _a.image, timestamp = _a.timestamp, isNew = _a.isNew, children = _a.children, locale = _a.locale;
    return (react_1.default.createElement("div", { className: "dcl notification-item" },
        react_1.default.createElement("div", { className: "dcl notification-item__image" },
            react_1.default.createElement(NotificationItemImage_1.default, __assign({}, image))),
        react_1.default.createElement("div", { className: "dcl notification-item__content" },
            children,
            react_1.default.createElement("p", { className: "dcl notification-item__content-timestamp" }, (0, time_1.default)(timestamp).locale(locale).fromNow())),
        isNew && react_1.default.createElement(NewNotification_1.default, { width: "8px", height: "8px" })));
}
exports.default = NotificationItem;
